var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert form-alert icon",class:[_vm.typeValue]},[(_vm.iconValue)?_c('i',{staticClass:"icon",class:[_vm.iconValue]}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }